'use client';

import { FC, JSX } from 'react';
import { SectionHeaderWithPagination } from '@intigral/ui/components/SectionHeaderWithPagination';
import { __ } from '../../../../translations';
import { Carousel2 } from '@intigral/ui';
import h from '../../../../helpers/common';
import { Poster } from '@intigral/shared/components/Poster';
import VerticalBlock from '../elements/VerticalBlock';
import useLanguage from '../../../../hooks/useLanguage';
// import VerticalBlock from '../elements/VerticalBlock';

interface CarouselWrapperProps {
    carousel: {
        id: string;
        title_resource_key: string;
    };
    isLoading: boolean;
    promotions: any[];
    promoHelpers: {
        getPromoButtons: (promotion: any) => {
            buttonsObject: {
                play: JSX.Element | undefined;
                isLocked: boolean;
                reminder: JSX.Element | undefined;
                watchlist: JSX.Element | undefined;
                details: JSX.Element | undefined;
            };
        };
        getPromoImages: (promotion: any) => { thumbnail: string; 465: string; 924: string; 1200: string };
        getProviderLogo: (promotion: any) => string;
    };
}

/**
 * CarouselWrapper Component
 * A reusable component for displaying vertical content layouts
 */
export const CarouselWrapper: FC<CarouselWrapperProps> = ({ carousel, isLoading, promotions, ...props }) => {
    // Hooks
    const language = useLanguage();

    // unique class name to address the swiper pagination
    const pagingId = `component-${Math.random().toString(36).slice(2, 11)}`;
    const paginationClass = `pagination-${pagingId}`;
    const title = __(carousel?.title_resource_key);

    // configure swiper settings
    const swiperSettings = {
        dir: language === 'ar' ? 'rtl' : 'ltr',
        pagination: {
            el: `.${paginationClass}`,
            clickable: true,
        },
        virtual: {
            addSlidesBefore: 6,
            addSlidesAfter: 6,
        },
        ...(promotions.length > 0 && {
            slidesPerView: 2,
            breakpoints: {
                560: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
                1500: {
                    slidesPerView: 5,
                },
            },
        }),
    };

    return (
        <div className="container full-width" ref={null} id={'CarouselWrapper'} data-test-id={carousel?.id}>
            <SectionHeaderWithPagination title={title} className={paginationClass} isLoading={isLoading} />
            <Carousel2 isLoading={isLoading} swiperSettings={swiperSettings} dir={language === 'ar' ? 'rtl' : 'ltr'}>
                {isLoading ? (
                    <Poster isLoading />
                ) : (
                    promotions?.map((item, index) => <VerticalBlock item={item} key={index} {...props} />)
                )}
            </Carousel2>
        </div>
    );
};

export default CarouselWrapper;
